import request from 'axios';
import { Formik } from 'formik';
import * as React from 'react';
import { themr } from 'react-css-themr';
import * as yup from 'yup';
function DumpOrderForm({ code, subscribeEndpoint, onComplete, onError, product, title = 'Gọi lại cho tôi', placeholder = 'Nhập số điện thoại', submitText = 'Gửi', theme = {}, }) {
    return (React.createElement("div", null,
        React.createElement("h2", null, title),
        React.createElement(Formik, { initialValues: { phone: '' }, validationSchema: yup.object().shape({
                phone: yup
                    .string()
                    .matches(/(0[0-9]{9})\b/, 'Điện thoại không hợp lệ'),
            }), onSubmit: ({ phone }, { setSubmitting, resetForm /* setErrors, setValues and other goodies */, }) => {
                const data = {
                    phone,
                    product: product.title,
                    price: product.salePrice.amount,
                    code,
                    url: typeof window !== 'undefined' && window.location.href,
                };
                request
                    .post(subscribeEndpoint, data)
                    .then(() => {
                    if (onComplete) {
                        onComplete(data);
                    }
                    else {
                        alert(`Cám ơn bạn đã đặt hàng, chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất!`);
                    }
                    resetForm();
                })
                    .catch(() => {
                    if (onError) {
                        onError(data);
                    }
                    else {
                        alert(`Không thể gửi! Bạn vui lòng điền lại số điện thoại.`);
                    }
                })
                    .finally(() => {
                    setSubmitting(false);
                });
            } }, ({ values, touched, errors, handleBlur, handleChange, submitForm, }) => {
            return (React.createElement("div", { className: theme.root },
                React.createElement("div", { className: theme.form },
                    React.createElement("input", { name: "phone", className: theme.input, value: values.phone, onBlur: handleBlur, onChange: handleChange, placeholder: placeholder }),
                    React.createElement("button", { className: theme.submit, onClick: () => submitForm() }, submitText)),
                React.createElement("div", { className: theme.error }, touched.phone ? errors.phone : undefined)));
        })));
}
export const defaultOrderFormTheme = {
    root: '',
    title: '',
    form: 'flex',
    input: '',
    submit: 'ph3 bg-rc',
    error: 'f7 red',
};
export default themr('OrderForm', {}, { composeTheme: 'softly' })(DumpOrderForm);
//# sourceMappingURL=index.js.map